import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import AuthService from '../../services/auth';
import { goToHrisUrl } from '../PrivateRoute/PrivateRoute';

function SsoLogin() {
    /** @type {{ target?: string }} */
    const { target } = useParams(); // Only accessible if route is /login/:target
    const navigate = useNavigate();
    const ssoToken = new URLSearchParams(useLocation().search).get('ssoToken'); // Only accessible if route contains ?ssoToken=

    const executeLogin = async () => {
        if (ssoToken) {
            const success = await AuthService.ssoLogin(ssoToken);
            if (success) {
                navigate(`/${target}`);
            } else {
                goToHrisUrl();
            }
        }
    };

    useEffect(() => { executeLogin(); }, []);
    return <></>;
}

export default SsoLogin;
